import { createTheme } from '@mui/material';

export const theme = createTheme({
	palette: {
		primary: {
			main: '#4198c5',
		},
		secondary: {
			main: '#f50057',
		},
		background: {
			default: '#fff',
		},
		divider: 'rgba(0,0,0,0.12)',
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 640,
			md: 1024,
			lg: 1200,
			xl: 1536,
		},
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				'@font-face': {
					fontFamily: 'Roboto',
				},
			},
		},
		MuiToolbar: {
			styleOverrides: {
				dense: {
					height: 50,
					minHeight: 50,
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					color: '#161718',
					'& label.Mui': {
						color: '#4198C5',
					},
					'& label.Mui-focused': {
						color: '#4198C5',
					},
					'& label.Mui-error': {
						color: '#ff0000',
					},
					'& .MuiInput-underline:after': {
						borderBottomColor: '#4198C5',
					},
					'& .MuiOutlinedInput-root': {

						height: '40px',
						borderRadius: '6px',

						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: "#d0d4da",
						},
						'&:hover fieldset': {
							borderColor: '#4198C5',
							borderWidth: '1px',
						},
						'&.Mui-focused fieldset': {
							borderColor: '#4198C5',
							borderWidth: '1px',
							outline: 'none',
						},
						'&.Mui-error fieldset': {
							borderColor: '#d0d4dA',
						},
					},
					'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
						display: 'none',
					},
					'& input[type=number]': {
						MozAppearance: 'textfield',
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					color: '#161718',
					'&.Mui-error .MuiOutlinedInput-notchedOutline': {
						borderColor: '#ff0000',
					},
					"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
						borderColor: "#4198c5",
						borderWidth: "1px",
					},
					"&:hover .MuiOutlinedInput-notchedOutline": {
						borderColor: "#4198c5",
					},
				},
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				},
			},
		},

		MuiInputLabel: {
			styleOverrides: {
				root: {
					color: "#616F82",
					zIndex: 0,
					"&.Mui-error": {
						"color": "#ff0000"
					}
				}
			}
		},
		MuiTabs: {
			styleOverrides: {
				root: {
							'&.MuiTabs-indicator': {
									backgroundColor: 'none !important',
								}
						}
					}
				}

	},
	typography: {
		fontFamily: 'Roboto',
		button: {
			textTransform: 'none',
		},
	},
});
